export const companiesKey = ['companies']
export const companiesForFiltersKey = ['companies', 'filters']
export const requiresEverifySweepPreviewKey = (companyId: number) => [
  'companies',
  companyId,
  'requiresEverifySweepPreview',
]
